import { NewTrip, Trip } from 'entities/Trip';
import { Document } from 'entities/Document/interfaces';
import {
  GET_NEW_TRIP_REQUEST,
  GET_NEW_TRIP_SUCCESS,
  GET_NEW_TRIP_ERROR,
  UPDATE_NEW_TRIP_SUCCESS,
  UPDATE_TRIP_REQUEST,
  UPDATE_TRIP_SUCCESS,
  UPDATE_TRIP_ERROR,
  DELETE_TRIP_REQUEST,
  DELETE_TRIP_ERROR,
  CLEAN_TRIP,
  CLEAN_ERROR,
  GET_TRIP_REQUEST,
  DELETE_TRIP_SUCCESS,
  GET_TRIP_SUCCESS,
  GET_TRIP_ERROR,
  SAVED_TRIP,
  FORCE_SAVED,
  SET_VISITOR_NAME,
  UPDATE_TRIP_STATUS,
  SET_SMS_FLAG,
  UPDATE_TRIP_STATUS_SUCCESS,
  DELETE_ORDER_FROM_TRIP_SUCCESS,
  DELETE_ORDER_FROM_TRIP_REQUEST,
  DELETE_ORDER_FROM_TRIP_ERROR,
  HAS_WARNING,
  CLEAN_WARNING,
  PUT_NEXT_STEP_REQUEST,
  PUT_NEXT_STEP_ERROR,
  PUT_NEXT_STEP_SUCCESS,
} from './constants';
import { Actions } from './actions';

const initialState = {
  loadingTrip: false as boolean,
  createNewTripLoading: false as boolean,
  errorTrip: null as any | null,

  trip: {} as NewTrip | Trip,
  docsData: [] as Document[],
  visitor: [] as any[],
  sms: [],

  saved: false,
  forceSave: null as null | string,

  warning: false as boolean,
  warningText: [] as any,
};

export type TripState = typeof initialState;

export const commonTripReducer = (state: TripState = initialState, action: Actions) => {
  switch (action.type) {
    case SET_VISITOR_NAME: {
      return {
        ...state,
        visitor: action.payload,
      };
    }
    case GET_TRIP_REQUEST:
    case DELETE_TRIP_REQUEST: {
      return {
        ...state,
        loadingTrip: true,
        errorTrip: null,
      };
    }
    case GET_NEW_TRIP_REQUEST: {
      return {
        ...state,
        loadingTrip: true,
        errorTrip: null,
        createNewTripLoading: true,
      };
    }
    case GET_NEW_TRIP_SUCCESS: {
      return {
        ...state,
        loadingTrip: false,
        createNewTripLoading: false,
        errorTrip: null,
        docsData: action.docs,
        trip: action.payload,
        saved: true,
      };
    }
    case UPDATE_NEW_TRIP_SUCCESS: {
      return {
        ...state,
        loadingTrip: false,
        errorTrip: null,
        trip: action.payload,
        saved: true,
      };
    }
    case DELETE_TRIP_ERROR:
    case GET_NEW_TRIP_ERROR: {
      return {
        ...state,
        loadingTrip: false,
        errorTrip: action.payload,
        createNewTripLoading: false,
      };
    }
    case UPDATE_TRIP_STATUS: {
      return {
        ...state,
        loadingTrip: true,
        errorTrip: null,
        trip: action.payload.trip,
      };
    }
    case UPDATE_TRIP_STATUS_SUCCESS: {
      return {
        ...state,
        loadingTrip: false,
      };
    }
    case UPDATE_TRIP_REQUEST: {
      return {
        ...state,
        loadingTrip: true,
        errorTrip: null,
        trip: action.payload.trip,
      };
    }
    case CLEAN_TRIP:
    case UPDATE_TRIP_SUCCESS: {
      return {
        ...state,
        loadingTrip: false,
        errorTrip: null,
        trip: {} as Trip,
        docsData: [],
        visitor: [],
        saved: false,
        forceSave: null,
      };
    }
    case UPDATE_TRIP_ERROR: {
      return {
        ...state,
        loadingTrip: false,
        loading: false,
        errorTrip: action.payload,
        docsData: [],
        visitor: [],
        saved: false,
        forceSave: null,
      };
    }

    case DELETE_TRIP_SUCCESS: {
      return {
        ...initialState,
      };
    }
    case GET_TRIP_SUCCESS: {
      return {
        ...state,
        loadingTrip: false,
        trip: action.payload,
        errorTrip: null,
      };
    }
    case GET_TRIP_ERROR: {
      return {
        ...state,
        loadingTrip: false,
        errorTrip: action.payload,
        saved: false,
      };
    }

    case SAVED_TRIP: {
      return {
        ...state,
        forceSave: null,
        saved: action.payload,
      };
    }

    case SET_SMS_FLAG: {
      return {
        ...state,
        sms: action.payload,
      };
    }
    case FORCE_SAVED: {
      return {
        ...state,
        forceSave: action.payload,
      };
    }

    case CLEAN_ERROR: {
      return {
        ...state,
        errorTrip: null,
        loadingTrip: false,
      };
    }
    case DELETE_ORDER_FROM_TRIP_REQUEST: {
      return {
        ...state,
        loadingTrip: true,
      };
    }
    case DELETE_ORDER_FROM_TRIP_SUCCESS: {
      return {
        ...state,
        loadingTrip: false,
        errorTrip: null,
        trip: action.payload,
        saved: true,
      };
    }
    case DELETE_ORDER_FROM_TRIP_ERROR: {
      return {
        ...state,
        loadingTrip: false,
      };
    }
    case HAS_WARNING: {
      return {
        ...state,
        loadingTrip: false,
        warning: action.warning,
        warningText: action.payload,
        docsData: action.docs,
        trip: action.trip,
      };
    }
    case CLEAN_WARNING: {
      return {
        ...state,
        loadingTrip: false,
        warning: false,
        warningText: [],
        loading: false,
      };
    }
    case PUT_NEXT_STEP_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case PUT_NEXT_STEP_SUCCESS: {
      return {
        ...state,
        loading: false,
        trip: {} as Trip,
      };
    }
    case PUT_NEXT_STEP_ERROR: {
      return {
        ...state,
        errorTrip: action.payload,
        trip: {} as Trip,
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
};
